// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BaseLayout from './components/layout/BaseLayout';
import ProverbsDaily from './pages/ProverbsDaily';
import Contact from './pages/Contact';
import AdminPanel from './components/admin/AdminPanel';
import ProtectedRoute from './components/auth/ProtectedRoute';
import NotificationTest from './components/NotificationTest';
import { initializeAnalytics } from './services/analytics';
import { initOneSignal } from './services/notifications';

function App() {
  useEffect(() => {
    // Initialize analytics
    initializeAnalytics();

    // Initialize OneSignal
    const setupOneSignal = async () => {
      try {
        await initOneSignal();
      } catch (error) {
        console.error('Error setting up OneSignal:', error);
      }
    };

    setupOneSignal();
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Routes - Wrapped in BaseLayout */}
        <Route path="/" element={
          <BaseLayout>
            <ProverbsDaily />
          </BaseLayout>
        } />
        <Route path="/contact" element={
          <BaseLayout>
            <Contact />
          </BaseLayout>
        } />
        
        {/* Test Routes */}
        <Route path="/test-notifications" element={
          <BaseLayout>
            <NotificationTest />
          </BaseLayout>
        } />
        
        {/* Admin Routes - No BaseLayout wrapper */}
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/edit" element={
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;